import { useCallback, useEffect, useState } from 'react'

export const useWindowKeyPress = ({
  targetKey,
  isEnabled = true,
}: {
  targetKey: string
  isEnabled?: boolean
}): boolean => {
  const [keyPressed, setKeyPressed] = useState(false)

  const downHandler = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === targetKey) {
        event.preventDefault()
        setKeyPressed(true)
      }
    },
    [targetKey],
  )

  const upHandler = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === targetKey) {
        event.preventDefault()
        setKeyPressed(false)
      }
    },
    [targetKey],
  )

  useEffect(() => {
    if (isEnabled) {
      return
    }
    setKeyPressed(false)
  }, [isEnabled])

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    if (!isEnabled) {
      return
    }
    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)
    return () => {
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
  }, [isEnabled, downHandler, upHandler])

  return isEnabled && keyPressed
}
